import { View } from "react-native";

const EmptyWheelItem = ({
	width,
	height,
	borderRadius,
}: {
	width: number;
	height: number;
	borderRadius: number;
}) => {
	return (
		<View
			style={{
				position: "absolute",
				width,
				height,
				backgroundColor: "#262B3999",
				borderRadius,
				overflow: "hidden",
			}}
		/>
	);
};
export default EmptyWheelItem;
